// Bancos suportados (código Febraban → nome). Reaproveita os logos SVG em
// public/banks/<código>.svg importados do crm-twms.

export interface Bank { code: string; name: string }

export const BANKS: Bank[] = [
  { code: '001', name: 'Banco do Brasil' },
  { code: '033', name: 'Santander' },
  { code: '036', name: 'Banco Bradesco BBI' },
  { code: '041', name: 'Banrisul' },
  { code: '077', name: 'Banco Inter' },
  { code: '104', name: 'Caixa Econômica Federal' },
  { code: '197', name: 'Stone' },
  { code: '208', name: 'BTG Pactual' },
  { code: '212', name: 'Banco Original' },
  { code: '237', name: 'Bradesco' },
  { code: '260', name: 'Nubank' },
  { code: '290', name: 'PagBank' },
  { code: '323', name: 'Mercado Pago' },
  { code: '336', name: 'Banco C6' },
  { code: '341', name: 'Itaú' },
  { code: '380', name: 'PicPay' },
  { code: '389', name: 'Banco Mercantil' },
  { code: '422', name: 'Banco Safra' },
  { code: '461', name: 'Asaas' },
  { code: '623', name: 'Banco PAN' },
  { code: '655', name: 'Banco Votorantim / Neon' },
  { code: '707', name: 'Banco Daycoval' },
  { code: '748', name: 'Sicredi' },
  { code: '756', name: 'Sicoob' },
]

export const BANK_LOGO_CODES = new Set(BANKS.map(b => b.code))
export const bankName = (code?: string | null) => BANKS.find(b => b.code === code)?.name
